import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const Reportbuilder1 = {
    name: 'Report Builder',
    imageUrl: '../../images/Reportbuilder.png',
    imageSize: "100%",
    bradius: 20,
  };
  export const Reportbuilder = () => {
    return (
      <div style={helpcanvas}>
        <div
        style={{ marginLeft: "310px" }}
        ></div>
        <div style={helptitle}><b>Generate a Report</b><br/><br/>
        Within this section, you can create reports based on the following scan types:
        <br/><br/>
        <ul style={{marginLeft: '4em'}}>
              <li>Data Scans</li>
              <li>Vulnerability Scans</li>
              <li>Secure Baseline Scans</li>
              <li>Dark Web Data</li>
              <li>Cyber Risk Assessment</li>
        </ul>
        <br/>
        To compile a report, follow these steps:
        <br/><br/>
        <ul style={{marginLeft: '4em'}}>
              <li>Pick the report date</li>
              <li>Select the scan name</li>
              <li>Choose the desired report format</li>
        </ul>
        <br/>
        There are two report options at your disposal:
        <br/><br/>
        <ul style={{marginLeft: '4em'}}>
              <li>Executive Summary: This report provides an overview of the scan, encompassing the overall grade, statistics regarding the target machines (including information on installed security software and OS end-of-life dates), and a count of vulnerabilities per target in the scan. Additionally, it features a bar chart comparison of specific targets within the scan. Below the bar chart comparison, you'll find a summary of each vulnerability and the associated targets affected by it.</li>
              <br/>
              <li>Full Detail: This comprehensive report includes the overall scan information, such as the grade, statistics on target machines, and a bar chart comparison of Critical, High, Medium, and Low CVEs on a per-target basis. It also contains a list of root causes, followed by a detailed list of CVEs.</li>
        </ul>
        <br/>
        For Dark Web scans, remember to select the type of report before generating it.
        <br/><br/>
        For Cyber Risk Assessment reports, specify the  criteria you want to include in your report from the following options:
        <br/><br/>
        <ul style={{marginLeft: '4em'}}>
              <li>External Vulnerability</li>
              <li>External Web Application</li>
              <li>Internal Authenticated Vulnerability</li>
              <li>Data Sensitivity (including monetization)</li>
              <li>Secure Baseline</li>
              <li>Dark Web</li>
        </ul>
        <br/>
        <b>Generated Reports</b><br/><br/>
        Here, you'll find essential information about the reports you've generated, including:
        <br/><br/>
        <ul style={{marginLeft: '4em'}}>
              <li>Scan name</li>
              <li>Type of report</li>
              <li>Issued by</li>
              <li>Date generated</li>
              <li>Date expiring</li>
        </ul>
        <br/><br/>
        In this section, you'll also find links to download generated reports.
        </div>
        <div style={helpimg}>
        <img
          src={Reportbuilder1.imageUrl}
          alt={'Image of ' + Reportbuilder1.name}
          style={{
            width: Reportbuilder1.imageSize,
            borderRadius: Reportbuilder1.bradius,
          }}
        />
        </div>
      </div>
    );
  };
